import * as React from "react";
import { Stack } from "@mui/material";
import RechargesTable from "../tables/RechargeTable";
import RechargesFilter from "../filters/RechargesFilter";

function Recharges() {

    return (
        <Stack direction={"column"} spacing={2} margin={"16px"}>
            <RechargesFilter/>
            <RechargesTable/>
        </Stack>
    )
}

export default Recharges;